import { useMutation } from 'react-query';

import { bulkDeleteUserActionsAndRecomendations as mutationFn } from 'api/endPoints/bulkDeleteUserActionsAndRecomendations';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationBulkDeleteAction = () => {
    return useMutation<string, QueryError, IBulkDeleteActionPayload>((params) => mutationFn(params));
};

interface IBulkDeleteActionPayload {
    filter: {
        filters: IFilter;
    };
    paging: {
        page: number;
        size: number;
    };
    uniqIdNotification: number;
}
